import { useState } from 'react'
import IdentityVerificationModal from '@/shared/consultation/components/modal/identity-verification-modal'
import IdentityVerificationConsentModal from '@/shared/consultation/components/modal/identity-verification-consent-modal'

interface Options {
  onVerificationSuccess?: () => void
}

export const useIdentityVerificationModals = ({ onVerificationSuccess }: Options) => {
  const [isConsentModalOpen, setIsConsentModalOpen] = useState(false)
  const [isVerificationModalOpen, setIsVerificationModalOpen] = useState(false)

  const openConsentModal = () => setIsConsentModalOpen(true)
  const closeConsentModal = () => setIsConsentModalOpen(false)

  const openVerificationModal = () => setIsVerificationModalOpen(true)
  const closeVerificationModal = () => setIsVerificationModalOpen(false)

  const identityVerificationModals = (
    <>
      {/* 본인인증 동의서 모달 */}
      <IdentityVerificationConsentModal
        isOpen={isConsentModalOpen}
        onClose={closeConsentModal}
        onAgree={() => {
          closeConsentModal()
          openVerificationModal()
        }}
      />

      {/* 본인인증 모달 */}
      <IdentityVerificationModal
        isOpen={isVerificationModalOpen}
        onClose={closeVerificationModal}
        onSuccess={() => {
          closeVerificationModal()
          onVerificationSuccess?.()
        }}
      />
    </>
  )

  return {
    openConsentModal,
    identityVerificationModals,
  }
}
